import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]

import QRCode from 'qrcode'
import { onMounted, ref, toRefs, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'qr-code',
  props: {
  value: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props
const { value } = toRefs(props)
const src = ref('')
function renderCanvas () {
  QRCode.toDataURL(props.value)
    .then((url: string) => {
      console.log(url)
      src.value = url
    })
}
onMounted(() => {
  renderCanvas()
})
watch(value, () => {
  if (props.value) renderCanvas()
})

return (_ctx: any,_cache: any) => {
  return (src.value)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: src.value
      }, null, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})